<script>
export default {
  name: "DidoExploreTextFilter",
};
</script>

<script setup>
import { ref } from "vue";

// define Props
const props = defineProps({
  text: { type: String, required: true },
});

// Define Emits
const emit = defineEmits(["new-text"]);

// define Reactive data
const textInput = ref(props.text);
</script>

<template>
  <QInput
    v-model="textInput"
    square
    filled
    label="Rechercher un jeu ou un fichier de données"
    dense
    bg-color="white"
    color="secondary"
    title="Entrez le texte à rechercher dans le titre ou la description d'un fichier ou d'un jeu de données"
    debounce="500"
    autogrow
    class="dido-explore-text-filter"
    @update:model-value="emit('new-text', textInput)"
  >
    <template #prepend>
      <QIcon name="mdi-magnify" />
    </template>
  </QInput>
</template>

<style lang="sass" scoped>
.dido-explore-text-filter
  :deep( .q-field__label)
    color: #999
</style>
